import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Shield, Lock, CreditCard, Zap, Check, Star } from 'lucide-react';
import { motion } from 'framer-motion';
const PLANS = [{
  id: 'basic',
  icon: '📘',
  name: 'SISTEMA CICLISTA PRO',
  originalPrice: '$27.990',
  price: '$19.990',
  url: 'https://tumanualdigital.com/cart/44182624534564:1'
}, {
  id: 'premium',
  icon: '🏆',
  name: 'SISTEMA + MASTER-PLAN 365',
  originalPrice: '$49.990',
  price: '$27.990',
  url: 'https://tumanualdigital.com/cart/44182625648676:1',
  featured: true
}];
export function FinalCTA() {
  const [selectedId, setSelectedId] = useState('premium');
  const selected = PLANS.find(p => p.id === selectedId) ?? PLANS[1];
  return <section className="py-14 px-4 max-w-4xl mx-auto text-center pt-[0px] pb-[0px]" data-id="element-130">
      <FadeIn data-id="element-131">
        <div className="bg-[#020617] rounded-[2rem] md:rounded-[2.5rem] p-6 md:p-12 border border-[#22c55e]/30 shadow-[0_20px_50px_rgba(2,6,23,0.15)] relative overflow-hidden" data-id="element-132">
          <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(#22c55e_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-133"></div>

          <div className="relative z-10" data-id="element-134">
            <h2 className="md:text-4xl font-black mb-6 md:mb-8 text-transparent bg-clip-text bg-gradient-to-r from-white to-[#e2e8f0] text-[24px] leading-tight" data-id="element-135">
              La próxima salida puede ser diferente. 🚴
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-2xl mx-auto mb-5 md:mb-6" data-id="element-136">
              {PLANS.map(plan => {
              const isSelected = plan.id === selectedId;
              return <button key={plan.id} type="button" onClick={() => setSelectedId(plan.id)} aria-pressed={isSelected} className={`relative text-left rounded-xl p-4 transition-all duration-200 ${isSelected ? 'bg-gradient-to-br from-[#22c55e]/20 to-[#0f172a] border-2 border-[#22c55e] shadow-[0_0_25px_rgba(34,197,94,0.3)] scale-[1.02]' : 'bg-[#0f172a] border-2 border-[#22c55e]/20 hover:border-[#22c55e]/50 opacity-70 hover:opacity-100'}`} data-id="element-137">
                    {plan.featured && <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-[#22c55e] text-[#020617] text-[10px] font-black px-2.5 py-0.5 rounded-full flex items-center gap-1 whitespace-nowrap shadow-md" data-id="element-138">
                        <Star className="w-3 h-3" fill="currentColor" data-id="element-139" /> MÁS
                        ELEGIDO
                      </div>}

                    {/* Radio indicator */}
                    <div className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? 'bg-[#22c55e] border-[#22c55e]' : 'bg-transparent border-[#475569]'}`} data-id="element-140">
                      {isSelected && <Check className="text-[#020617] w-3 h-3" strokeWidth={4} data-id="element-141" />}
                    </div>

                    <div className="pr-7 pt-1" data-id="element-142">
                      <h3 className="font-bold text-sm md:text-base text-white flex items-center gap-1.5 mb-2 leading-tight" data-id="element-143">
                        <span data-id="element-144">{plan.icon}</span> {plan.name}
                      </h3>
                      <div className="flex items-baseline gap-2" data-id="element-145">
                        <span className="text-[#ef4444] line-through text-xs font-bold" data-id="element-146">
                          {plan.originalPrice}
                        </span>
                        <span className={`text-xl md:text-2xl font-black ${plan.featured ? 'text-[#22c55e]' : 'text-white'}`} data-id="element-147">
                          {plan.price}
                        </span>
                        <span className="text-[10px] text-[#475569] font-bold" data-id="element-148">
                          ARS
                        </span>
                      </div>
                    </div>
                  </button>;
            })}
            </div>

            {/* Shared CTA */}
            <motion.a key={selected.id} initial={{
            opacity: 0.7,
            y: 5
          }} animate={{
            opacity: 1,
            y: 0
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} href={selected.url} className="max-w-xl mx-auto block text-center py-4 md:py-5 px-4 rounded-xl font-black text-base md:text-lg bg-[#22c55e] hover:bg-[#4ade80] text-[#020617] transition-colors shadow-[0_10px_30px_rgba(34,197,94,0.4)] mb-6" data-id="element-149">
              → COMPRAR · {selected.price} ARS
            </motion.a>

            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-[#e2e8f0] font-bold" data-id="element-150">
              <span className="flex items-center gap-1.5" data-id="element-151">
                <Lock size={16} className="text-[#22c55e]" data-id="element-152" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-153">
                <Zap size={16} className="text-[#22c55e]" data-id="element-154" /> Acceso en 5 min
              </span>
              <span className="flex items-center gap-1.5" data-id="element-155">
                <Shield size={16} className="text-[#22c55e]" data-id="element-156" /> Garantía 7 días
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-x-4 mt-3 text-xs md:text-sm text-[#475569] font-medium" data-id="element-157">
              <span className="flex items-center gap-1.5" data-id="element-158">
                <CreditCard size={14} data-id="element-159" /> Mercado Pago · Tarjeta · Transferencia
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}